import createReboundMethod from './createReboundMethod';

var createTransform = function createTransform(transforms) {
  return function (name) {
    return transforms.reduce(function (name, fn) {
      return name && fn(name);
    }, name);
  };
};

export default (function (target, source) {
  for (var _len = arguments.length, transforms = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    transforms[_key - 2] = arguments[_key];
  }

  var transform = createTransform(transforms);

  for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
    var name = _Object$keys[_i];
    var result = transform(name);

    if (result) {
      target[result] = createReboundMethod(target, source, name);
    }
  }

  return target;
});